export default __webpack_public_path__ + "static/media/MOLECULAR Glougloux.cf378d22.jpg";